import React from 'react';


export default function ObjectivePicker(props) {
  const handleObjectiveChange = (event) => {
    const newObjective = event.target.value;
    props.setDashboardObjective(newObjective);
  };

  return (
    <div className="objective-picker-container">
      <div className="objective-label">Objective:</div>
      <div className="select-wrapper-objective">
        <select
          className="objective-picker dashboard-objective"
          name="dashboard_objective"
          value={props.dashboardObjective}
          onChange={handleObjectiveChange}
        >
          <option value="sales">Sales</option>
          <option value="conversions">Conversions</option>
        </select>
      </div>
    </div>
  )
}